import confirm from '@jetbrains/ring-ui/components/confirm-service/confirm-service';
export default function confirmResetForm() {
    return confirm({
        text: 'Exit Without Saving Changes?',
        description: 'All unsaved changes will be discarded',
        confirmLabel: 'Confirm',
        rejectLabel: 'Cancel'
    });
}
